import 'react-app-polyfill/ie11';
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from 'containers/app/App';
import Login from 'pages/Login';
import Permission from 'pages/Permission';
import "@babel/polyfill"
//import * as serviceWorker from './serviceWorker';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import ScrollToTop from 'components/scrollToTop/ScrollToTop';
import 'locales/i18n';
import PrivateRoute from 'components/PrivateRoute';
import {Provider} from 'react-redux';
import ProgressCustom from "components/ProgressCustom";
import MessageBox from "components/MessageBox";
import Dialog from "./components/Dialog";
import store from "reactRedux/store/store";

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <>
                <ProgressCustom/>
                <MessageBox/>
                <Dialog/>
                <ScrollToTop>
                    <Suspense fallback="">
                        <Switch>
                            <Route path="/login" exact component={Login}/>
                            <Route path="/permission/:error_code" exact component={Permission}/>
                            <PrivateRoute path="/" component={App}/>
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();